// extracted by mini-css-extract-plugin
export var menuItem = "menu-item-module--menuItem--6fee2";
export var title = "menu-item-module--title--195f4";